export default __webpack_public_path__ + "static/media/vw.2e25b0dd.svg";